import clsx from 'clsx'
import LifecycleLink from '@/components/common/LifecycleLink'
import Image from 'next/image'
import { URL_SUBSCRIBE } from '@/constant/subscribe'
import useI18n from 'Hooks/useI18n'
import { withLocale } from '@/locales'
import { GemIcon } from '@/components/svg'
import useUserWallet from '@/hooks/swr/useUserWallet'
import { formatMessageAmount } from '@/utils/subscribe'
import { BalanceInfiniteIcon } from '@/components/svg'
import { PlusOutlined } from '@ant-design/icons'

const SubscribeButton = () => {
  const { t, lang } = useI18n()
  const {
    userWalletInfo: { leftFreeMsgAmount },
  } = useUserWallet()

  return (
    <>
      <LifecycleLink
        href={withLocale(URL_SUBSCRIBE, lang)}
        prefetch
        className={clsx(
          'pointer-events-auto inline-flex h-[36px] cursor-pointer items-center whitespace-nowrap rounded-full border border-secondary-border bg-secondary-bg px-3 text-[14px] leading-4',
          'hover:border-hover-border'
        )}
      >
        {/* 蓝宝石图标 */}
        <GemIcon size={20} colorType="blue" className="flex-shrink-0" />
        {/* 蓝宝石数量 */}
        <span className="ml-1 mr-2 text-[#8BA2EE]">
          {leftFreeMsgAmount === 'inf' ? (
            <BalanceInfiniteIcon width={23} height={11} />
          ) : (
            formatMessageAmount(t, leftFreeMsgAmount)
          )}
        </span>
        <span className="flex h-5 w-5 items-center justify-center rounded-full border border-white/20 transition-colors group-hover:border-hover-border">
          <PlusOutlined className="text-xs text-white" />
        </span>
      </LifecycleLink>
    </>
  )
}

export default SubscribeButton
